import realtimeMock from '../mock/realtime.json';

export const fetchRealtimeView = async () => {
  // Placeholder: currently serve local mock; wire API once SIT has data
  return realtimeMock;
};
